import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';

export default function ItemDetail() {
  const { username, contract, identifier } = useParams();
  const [nft, setNft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [price, setPrice] = useState(''); // Цена для установки
  const [userLoading, setUserLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);

  // Состояние для отметки чекбокса принятия политики
  const [isPolicyChecked, setIsPolicyChecked] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Загружаем данные текущего пользователя
    const fetchCurrentUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const userResponse = await axios.get('https://nifty-art.com/api/auth/user', {
            headers: { Authorization: `Bearer ${token}` },
          });
          // Преобразуем admin в булево, если оно приходит как строка
          const userData = {
            ...userResponse.data,
            user: {
              ...userResponse.data.user,
              admin:
                userResponse.data.user.admin === true ||
                userResponse.data.user.admin === 'true',
            },
          };
          setCurrentUser(userData);
        } else {
          setCurrentUser(null);
        }
      } catch (error) {
        setCurrentUser(null);
      } finally {
        setUserLoading(false);
      }
    };

    const fetchNFT = async () => {
      try {
        const response = await axios.get(
          `https://nifty-art.com/api/nfts/${username}/${contract}/${identifier}`
        );
        setNft(response.data);
        setPrice(response.data.price);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchCurrentUser();
    fetchNFT();
  }, [contract, username, identifier]);

  useEffect(() => {
    if (!userLoading && !loading) {
      const token = localStorage.getItem('token');
      const metamaskAddr = currentUser?.user?.metamaskAddress;
      setShowAuthModal(!token || !metamaskAddr);
    }
  }, [userLoading, loading, currentUser]);

  const handleSetPrice = async () => {
    try {
      const token = localStorage.getItem('token'); // Получаем токен из локального хранилища
      const response = await axios.put(
        `https://nifty-art.com/api/nfts/${contract}/${identifier}/set-price`,
        {
          price,
          forSale: true,
          name: nft.name,
          description: nft.description,
          image: nft.image,
          contract: nft.contract,
          category: nft.category,
          identifier: nft.identifier,
          token_standard: nft.token_standard,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNft({ ...nft, price: response.data.nft.price, forSale: true });
    } catch (error) {
      // Обработка ошибки
    }
  };

  const handleRemoveFromSale = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `https://nifty-art.com/api/nfts/${contract}/${identifier}/remove-from-sale`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNft({ ...nft, forSale: false });
    } catch (error) {
      // Обработка ошибки
    }
  };

  const handleBuyNow = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        // Если нет токена, пользователь не авторизован
        return;
      }

      const requestData = {
        amount: nft.price,
        items: [
          {
            _id: nft._id,
            price: nft.price,
          },
        ],
      };

      const response = await axios.post(
        'https://nifty-art.com/api/nfts/test',
        requestData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        window.location.href = response.data.url; // перенаправляем на форму оплаты
      } else {
        // Обработка ошибки
      }
    } catch (error) {
      // Обработка ошибки
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <img
          src={require('../../assets/images/loading.gif')}
          alt="Loading..."
          className="w-10000 h-10000"
        />
      </div>
    );
  }

  if (!nft) return <p>NFT not found</p>;

  const isOwner = currentUser?.user?.username === nft.owner?.username;
  const isAdmin = currentUser?.user?.admin === true;
  const isAdminOwner = isOwner && isAdmin;

  return (
    <>
      <Navbar />

      {/* Если пользователь НЕ авторизован или НЕ метамаск - показать модалку (если showAuthModal=true) */}
      {showAuthModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white dark:bg-slate-800 w-[90%] max-w-md rounded-lg shadow-lg p-6 relative">
            <h2 className="text-xl font-semibold text-slate-700 dark:text-white mb-2">
              Please Connect
            </h2>
            {!currentUser ? (
              <p className="text-slate-500 dark:text-slate-300 mb-4">
                To access this feature, you need to log in.
              </p>
            ) : (
              <p className="text-slate-500 dark:text-slate-300 mb-4">
                To access this feature, please connect your Metamask account.
              </p>
            )}
            <div className="flex gap-2">
              {!currentUser ? (
                <button
                  onClick={() => navigate('/login')}
                  className="bg-violet-600 hover:bg-violet-700 text-white px-6 py-2 rounded-full font-medium"
                >
                  Login
                </button>
              ) : (
                <a
                  href={`https://nifty-art.com/creator-profile-edit/${currentUser.user._id}`}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-violet-600 hover:bg-violet-700 text-white px-6 py-2 rounded-full font-medium"
                >
                  Connect Metamask
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      <section className="relative pt-28 md:pb-24 pb-16">
        <div className="container">
          <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-[30px]">
            <div className="lg:col-span-5">
              <img
                src={
                  nft.image.startsWith('/uploads/nfts/')
                    ? `https://nifty-art.com${nft.image}`
                    : nft.image
                }
                className="rounded-lg shadow-md dark:shadow-gray-700 group-hover:scale-110 transition-all duration-500"
                alt={nft.name}
              />

              <div className="bg-gray-50 dark:bg-slate-800 rounded-md shadow dark:shadow-gray-800 mt-[30px] p-6">
                <div>
                  <span className="font-medium text-slate-400 block mb-1">Contract Address</span>
                  <Link
                    to="#"
                    className="font-medium text-violet-600 underline block"
                  >
                    {nft.contract || '1fsvtgju51ntgeryimghf6ty7o9n3r3er246'}
                  </Link>
                </div>
                <div className="mt-4">
                  <span className="font-medium text-slate-400 block mb-1">Token ID</span>
                  <span className="font-medium block">
                    {nft._id
                      ? `${nft._id.slice(0, 5)}...${nft._id.slice(-5)}`
                      : 'Unavailable'}
                  </span>
                </div>

                <div className="mt-4">
                  <span className="font-medium text-slate-400 block mb-1">Blockchain</span>
                  <span className="font-medium block">Polygone</span>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7 lg:ms-8">
              <h5 className="md:text-2xl text-xl font-semibold">{nft.name}</h5>
              <span className="font-medium text-slate-400 block mt-2">
                From this collection:{' '}
                <Link
                  to={`/creator-profile/${nft.owner.username}`}
                  className="text-violet-600"
                >
                  {nft.owner.username}
                </Link>
              </span>
              <p className="text-slate-400 mt-4">{nft.description}</p>

              <div className="mt-4">
                {isAdminOwner ? (
                  // Если пользователь является владельцем и администратором
                  <div className="mt-4">
                    {nft.forSale ? (
                      <>
                        <span className="text-lg font-medium text-slate-400 block">
                          Current Price
                        </span>
                        <span className="md:text-2xl text-xl font-semibold block mt-2">
                          <i className="mdi mdi-ethereum"></i> {nft.price} €
                        </span>
                        <button
                          onClick={handleRemoveFromSale}
                          className="btn bg-red-600 hover:bg-red-700 border-red-600 hover:border-red-700 text-white rounded-full mt-4"
                        >
                          Remove from Sale
                        </button>
                      </>
                    ) : (
                      <>
                        <div className="mt-4 bg-slate-800 p-4 rounded-md shadow-md">
                          <span className="text-lg font-medium text-slate-400 block">
                            Set Price
                          </span>
                          <input
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            className="border rounded-md px-3 py-2 mt-2 w-1/2 bg-slate-900 text-white 
                                       focus:outline-none focus:ring-2 focus:ring-violet-600"
                            placeholder="Enter price in €"
                          />
                        </div>
                        <button
                          onClick={handleSetPrice}
                          className="btn bg-green-600 hover:bg-green-700 border-green-600 hover:border-green-700 
                                     text-white rounded-full mt-4"
                        >
                          Set for Sale
                        </button>
                      </>
                    )}
                  </div>
                ) : isOwner ? (
                  // Пользователь является владельцем, но не администратором
                  <div className="mt-4">
                    <p className="text-slate-500 dark:text-slate-300">
                      To gain access to selling your NFTs, please contact us.
                    </p>
                    <button
                      onClick={() => navigate('/contact')}
                      className="btn bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 
                                 text-white rounded-full mt-4"
                    >
                      Contact Us
                    </button>
                  </div>
                ) : (
                  // Пользователь не является владельцем (покупатель)
                  <div className="mt-4">
                    <span className="text-lg font-medium text-slate-400 block">
                      Market Price
                    </span>
                    <span className="md:text-2xl text-xl font-semibold block mt-2">
                      {nft.price} €
                    </span>

                    {nft.forSale ? (
                      <>
                        {/* 
                          ============= DESKTOP =============
                          Кнопка-круг, расширяющаяся по горизонтали при hover
                        */}
                        <div className="hidden md:block group relative mt-4">
                          <div
                            className="w-40 group-hover:w-[30rem] h-14 bg-violet-600 
                                       rounded-full overflow-hidden transition-all duration-300
                                       relative flex items-center justify-center"
                          >
                            {/* Текст "Buy Now", видимый до наведения */}
                            <span className="text-white font-semibold transition-opacity duration-300 group-hover:opacity-0 whitespace-nowrap">
                              Buy Now
                            </span>

                            {/* Расширенный контент (чекбокс и текст), появляется при hover */}
                            <div className="absolute inset-0 flex items-center px-4 gap-2
                                            opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                              <input
                                type="checkbox"
                                checked={isPolicyChecked}
                                onChange={(e) => setIsPolicyChecked(e.target.checked)}
                                className="cursor-pointer"
                              />
                              <span className="text-sm text-white">
                                I declare that I have read, understand and accept the{' '}
                                <a
                                  href="/terms"
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-pink-400 underline"
                                >
                                  Terms and Conditions
                                </a>
                              </span>

                              {/* Финальная кнопка «Buy Now» */}
                              <button
                                onClick={handleBuyNow}
                                disabled={!isPolicyChecked}
                                className="ml-auto bg-violet-700 hover:bg-violet-800 px-3 py-1 
                                           rounded-full text-white font-semibold
                                           disabled:opacity-50 disabled:cursor-not-allowed
                                           transition-colors duration-300 whitespace-nowrap"
                              >
                                Buy Now
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* 
                          ============= MOBILE =============
                          Плашка, раскрывающаяся вертикально (по сути, всегда раскрыта)
                        */}
                        <div className="md:hidden bg-violet-600 p-4 rounded-lg text-white mt-4">
                          {/* Чекбокс и текст */}
                          <div className="flex items-start mb-2">
                            <input
                              type="checkbox"
                              checked={isPolicyChecked}
                              onChange={(e) => setIsPolicyChecked(e.target.checked)}
                              className="cursor-pointer mt-1"
                            />
                            <span className="ml-2">
                              I declare that I have read, understand and accept the{' '}
                              <a
                                href="/terms"
                                target="_blank"
                                rel="noreferrer"
                                className="text-pink-400 underline"
                              >
                                Terms and Conditions
                              </a>
                            </span>
                          </div>

                          {/* Кнопка «Buy Now» */}
                          <button
                            onClick={handleBuyNow}
                            disabled={!isPolicyChecked}
                            className="bg-violet-700 hover:bg-violet-800 px-3 py-2 rounded-full text-white font-semibold 
                                       disabled:opacity-50 disabled:cursor-not-allowed
                                       transition-colors duration-300"
                          >
                            Buy Now
                          </button>
                        </div>
                      </>
                    ) : (
                      <span className="text-lg font-medium text-red-600 block mt-2">
                        NOT FOR SALE
                      </span>
                    )}
                  </div>
                )}
              </div>

              <div className="md:flex p-6 bg-gray-50 dark:bg-slate-800 rounded-lg shadow dark:shadow-gray-700 mt-6">
                <div className="md:w-1/2">
                  <div className="flex items-center">
                    <img
                      src={`https://nifty-art.com${nft.owner.avatar}`}
                      className="h-16 rounded-md"
                      alt={nft.owner.firstName}
                    />
                    <div className="ms-3">
                      <Link
                        to={`/creator-profile/${nft.owner.username}`}
                        className="font-semibold block hover:text-violet-600"
                      >
                        {nft.owner.firstName} {nft.owner.lastName}
                      </Link>
                      <span className="text-slate-400 text-[16px] block mt-1">
                        Owner
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
